import { Link, Typography } from '@mui/material';
import DownloadSimpleIcon from '../../../assets/svg-fc/DownloadSimpleIcon';
import { fetchPdfMedia } from '../../../helpers/common';
import { useToast } from '../../../context/ToasterContext';
import IsMobile from '../../../hooks/isMobile';

interface IInvoiceLinkProps {
  invoiceName: string;
  invoiceUrl: string;
}

const InvoiceLink = ({ invoiceName, invoiceUrl }: IInvoiceLinkProps) => {
  const isMobile = IsMobile();
  const { showToast } = useToast();

  const openPdfFile = async (url: string) => {
    const isOpened = await fetchPdfMedia(url);
    if (!isOpened) {
      showToast('Allow browser popups to view media', () => {}, 'warning');
    }
  };

  return (
    <Link
      underline="none"
      onClick={() => {
        openPdfFile(invoiceUrl);
      }}
      sx={{
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
      }}
    >
      <Typography
        component="span"
        sx={{
          textDecoration: 'underline',
          fontSize: isMobile ? '16px' : '18px',
          lineHeight: '16px',
          fontWeight: 500,
        }}
      >
        {invoiceName}
      </Typography>
      <Typography
        component="span"
        sx={{
          textDecoration: 'underline',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <DownloadSimpleIcon />
      </Typography>
    </Link>
  );
};

export default InvoiceLink;
